<template>
  <div class="container-fluid">
    <route-header>
      <h3>{{ $tc('labels.project', 0) }}</h3>
    </route-header>
    <div class="row">
      <div class="col-12">
        <projects />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ProjectsView',
  computed: {
    ...mapState({
      auth: state => state.auth
    })
  }
}
</script>
